import LinkButton from '../../utils/LinkButton';

function GetStarted({ children }) {
  return (
    <div className=" my-5 text-center ">
      {children}

      {/* For mobile view */}

      <div className="flex justify-center  p-4">
        <img
          className="md:hidden max-w-full h-auto "
          src='/images/download-qr.svg'
          alt="get started"
        />
      </div>

      {/* For desktop view */}
      <div className="flex justify-center  p-4">
        <img
          className="hidden md:block max-w-full h-auto my-5"
          src="/images/get-started-2.svg"
          alt="get started"
        />

        <img
          className="md:hidden max-w-full h-auto my-5"
          src="/images/get-started.svg"
          alt="get started"
        />
      </div>
      <LinkButton
        link="/sign-up"
        className="bg-[#FFDE11] font-bold text-xl px-20 py-3  my-5 inline rounded-full"
      >
        Sign up
      </LinkButton>
    </div>
  );
}

export default GetStarted;
